import { Flex } from '@/components/Common';
import { theme } from '@/constants';
import { useGlobalState, useHighlightString } from '@/hooks';
import type { ISingleItem } from '@/interfaces';
import type { ITrackingLeftPanel } from '@/modules/pmt/interfaces';
import { extractTextInsideAndOutsideDoubleCurlyBraces, getMasterTranslationLanguageCode } from '@/utils';
import { getCurrentTextOfMultipleLanguageField } from '@/utils/text.utils';
import type { FC } from 'react';
import {
  PMTLogo,
  TrackingImageWrapper,
  TrackingLeftPanelWrapper,
  TrackingPanelHeader,
  TrackingValueAnnouncementLabel,
  TrackingValueDescription,
  TrackingValueItem,
  TrackingValueItemList,
  TrackingValueTitle,
} from './TrackingLeftPanel.styles';

export const TrackingLeftPanel: FC<ITrackingLeftPanel> = ({ joinUsHeader, joinUsValuePropositionList }) => {
  const { pmtCurrentLanguageCode } = useGlobalState();
  const languageField = getMasterTranslationLanguageCode(pmtCurrentLanguageCode);

  const highlightCss = {
    color: theme.colors.darkOrange,
    textDecoration: 'underline',
    textUnderlinePosition: 'under',
    textDecorationThickness: '0.15rem',
  };

  const highlightedString = useHighlightString(joinUsHeader, highlightCss, 'span');

  return (
    <TrackingLeftPanelWrapper>
      <PMTLogo />
      {joinUsHeader && <TrackingPanelHeader>{highlightedString}</TrackingPanelHeader>}

      {!!joinUsValuePropositionList?.length && (
        <TrackingValueItemList>
          {joinUsValuePropositionList.map(({ id, title, description, icon }: ISingleItem) => {
            const _title = getCurrentTextOfMultipleLanguageField(title, languageField);
            const _description = getCurrentTextOfMultipleLanguageField(description, languageField);

            const { inside: announcementLabels, outside: rawText } =
              extractTextInsideAndOutsideDoubleCurlyBraces(_title);
            const announcementLabel = announcementLabels[announcementLabels.length - 1];
            return (
              <TrackingValueItem key={id}>
                <TrackingImageWrapper>
                  <img width={30} height={30} alt={_title} src={icon?.url || ''} />
                </TrackingImageWrapper>
                <div>
                  <Flex>
                    <TrackingValueTitle>{rawText}</TrackingValueTitle>
                    {announcementLabel && (
                      <TrackingValueAnnouncementLabel>{announcementLabel}</TrackingValueAnnouncementLabel>
                    )}
                  </Flex>
                  <TrackingValueDescription>{_description}</TrackingValueDescription>
                </div>
              </TrackingValueItem>
            );
          })}
        </TrackingValueItemList>
      )}
    </TrackingLeftPanelWrapper>
  );
};
